// extracted by mini-css-extract-plugin
export default {"divider":"divider__SLMe1","termBox":"termBox__VjgI_","submitBox":"submitBox__msOG_"};